import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

function HamiMall() {
	let SwiperStep = () => {
    return (
        <div className="si_tab hamimall_tab">
            <Swiper
                spaceBetween={50}
                slidesPerView={1}
								pagination={{ clickable: true }}
								allowTouchMove={false}
                navigation
            >
						<SwiperSlide>
							<div className="p2sld">
								<img src={require("../../image/hamimall/p2-s1.png").default} alt="p2-s1" />
							</div>
						</SwiperSlide>
						<SwiperSlide>
							<div className="p2sld">
								<img src={require("../../image/hamimall/p2-s2.png").default} alt="p2-s2" />
							</div>
						</SwiperSlide>
						<SwiperSlide>
							<div className="p2sld">
								<img src={require("../../image/hamimall/p2-s3.png").default} alt="p2-s3" />
							</div>
						</SwiperSlide>
            </Swiper>
        </div>
    )
	}

	let SwiperSpeaker = () => {
    return (
        <div className="si_tab hamimall_tab">
            <Swiper
							spaceBetween={50}	//Slide之間的距離
							slidesPerView={1} //一頁顯示幾個slide 
							pagination={{ clickable: true }}
							allowTouchMove={false}
							navigation	//左右箭頭導航
            >
							<div className="p3sld">
								<SwiperSlide>
										<img src={require("../../image/hamimall/p3s1.png").default} alt="p3s1" />
										<a href="https://www.hamimall.com.tw/order.php?id=300734" className="p3sbtn" target="_blank" rel="noreferrer">
											<img src={require("../../image/hamimall/p3sbtn.png").default} alt="p3sbtn" />
										</a>
								</SwiperSlide>
								<SwiperSlide>
										<img src={require("../../image/hamimall/p3s2.png").default} alt="p3s2" />
										<a href="https://eshop.cht.com.tw/Ace/Device/Verify?applytype=NEW&applicanttype=Personal&isMOB=true&chtModel=AI000000&color=%E7%81%B0&productID=020000002777" className="p3sbtn" target="_blank" rel="noreferrer">
											<img src={require("../../image/hamimall/p3sbtn.png").default} alt="p3sbtn"/>
										</a>
								</SwiperSlide>
							</div>
            </Swiper>
        </div>
    )
	}

	return (
		<div className="wrapper">
			<div className="kv">
				<img src={require("../../image/hamimall/kv.jpg").default} alt="kv" className="d-none d-lg-block hamimall_img" style={{width: "100%"}} />
				<img src={require("../../image/hamimall/kv-m.jpg").default} alt="kv-m" className="d-lg-none d-block hamimall_img" />
			</div>
			<div className="ma-con">
				<div className="p1">
					<div className="container">
						<div className="p1ti1">
							<img src={require("../../image/hamimall/p1ti1.png").default} alt="p1ti1" className="lgs hamimall_img" />
							<img src={require("../../image/hamimall/p1ti1-m.png").default} alt="p1ti1-m" className="mbs hamimall_img"/ >
						</div>
						<div className="p1-c1">
						</div>
						<div className="p1-c2">
							<img src={require("../../image/hamimall/p1-c2-ti.png").default} alt="p1-c2-ti" className="lgs hamimall_img" />
							<img src={require("../../image/hamimall/p1-c2-ti-m.png").default} alt="p1-c2-ti-m" className="mbs hamimall_img" />
							<div className="p1-c2-word">
								<p>衛生紙、洗衣膠囊、沐浴乳、洗碗精…等，甚至還有蔬菜箱、火鍋鍋物組
									幫您省去超市賣場補貨的時間跟搬貨回家的氣力，居家生活好幫手</p>
							</div>
						</div>
						<div className="p1-c3">
							<div className="p1c3-sl"></div>
						</div>
					</div>
				</div>
				<div className="p2">
					<div className="container">
						<div className="p-ti p2-ti">
							<img src={require("../../image/hamimall/p2-ti.png").default} className="hamimall_img" alt="p2-ti" />
						</div>
						<div className="p2-sl">
							<SwiperStep/>
						</div>
						<a href="/container/teaching/Teaching0205" target="_blank" className="p2-btn">
							<img src={require("../../image/hamimall/p2-btn.png").default} className="hamimall_img" alt="p2-btn" />
						</a>
					</div>
				</div>
				<div className="p3">
					<div className="container">
						<div className="p3ti1 p-ti">
							<img src={require("../../image/hamimall/p3ti1.png").default} className="lgs hamimall_img" alt="p3ti1" />
							<img src={require("../../image/hamimall/p3ti1-m.png").default} className="mbs hamimall_img" alt="p3ti1-m" />
						</div>
						<div className="p3c1">
							<img src={require("../../image/hamimall/p3img1.png").default} alt="p3img1" className="lgs hamimall_img" style={{width: "100%"}} />
							<img src={require("../../image/hamimall/p3img1-m.png").default} alt="p3img1-m" className="mbs hamimall_img" />
						</div>
						<div className="p3ti2 p-ti">
							<img src={require("../../image/hamimall/p3ti2.png").default} alt="p3ti2" className="lgs hamimall_img" />
							<img src={require("../../image/hamimall/p3ti2-m.png").default} alt="p3ti2-m" className="mbs hamimall_img" />
						</div>
						<div className="p3-sl">
							<SwiperSpeaker />
						</div>
						<a href="/" target="_blank" className="p2-btn">
							<img src={require("../../image/hamimall/p3-btn1.png").default} alt="p3-btn1" className="hamimall_img" />
						</a>
						<div className="p3ti3 p-ti">
							<img src={require("../../image/hamimall/p3ti3.png").default} alt="p3ti3" className="lgs hamimall_img" />
							<img src={require("../../image/hamimall/p3ti3-m.png").default} alt="p3ti3-m" className="mbs hamimall_img" />
							<img src={require("../../image/hamimall/p3-des.png").default} alt="p3-des" className="lgs hamimall_img" />
							<img src={require("../../image/hamimall/p3-des-m.png").default} alt="p3-des-m" className="mbs hamimall_img" />
						</div>
						<div className="row p3c3">
							<a href=" " className="col lgs">
								<img src={require("../../image/hamimall/icon1.png").default} alt="icon1" />
							</a>
							<a href=" " className="col lgs">
								<img src={require("../../image/hamimall/icon2.png").default} alt="icon2" />
							</a>
							<a href=" " className="col lgs">
								<img src={require("../../image/hamimall/icon3.png").default} alt="icon3" />
							</a>
							<a href=" " className="col mbs">
								<img src={require("../../image/hamimall/icon1-m.png").default} alt="icon1-m" />
							</a>
							<a href=" " className="col mbs">
								<img src={require("../../image/hamimall/icon2-m.png").default} alt="icon2-m" />
							</a>
							<a href=" " className="col mbs">
								<img src={require("../../image/hamimall/icon3-m.png").default} alt="icon3-m" />
							</a>
						</div>
						<a href="https://hamipoint.cht.com.tw/transpoint" target="_blank" className="p3-btn" rel="noreferrer">
							<img src={require("../../image/hamimall/p3-btn.png").default} alt="p3-btn" />
						</a>
					</div>
				</div>
			</div>
		</div>
	)
}

export default HamiMall;